import React, { useEffect, useState } from 'react';
import { useWs } from '@/lib/WsContext';
import api from '@/lib/api';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function WarningBanner() {
  const { subscribe } = useWs();
  const [current, setCurrent] = useState(null);
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    // Load unread warnings
    api.get('/notifications/warnings').then(({ data }) => {
      const unread = data.filter((w) => !w.read);
      if (unread.length > 0) {
        setCurrent(unread[0]);
        setQueue(unread.slice(1));
      }
    }).catch((e) => { console.debug('[WarningBanner] load warnings failed', e); });
  }, []);

  useEffect(() => {
    const unsub = subscribe((msg) => {
      if (msg.event === 'warning') {
        if (!current) setCurrent(msg.data);
        else setQueue((q) => [...q, msg.data]);
      }
    });
    return unsub;
  }, [subscribe, current]);

  const acknowledge = async () => {
    if (!current) return;
    try { await api.post(`/notifications/warnings/${current.id}/read`); } catch (e) { console.debug('[WarningBanner] ack failed', e); }
    if (queue.length > 0) {
      setCurrent(queue[0]);
      setQueue((q) => q.slice(1));
    } else {
      setCurrent(null);
    }
  };

  return (
    <AnimatePresence>
      {current && (
        <motion.div
          initial={{ y: -60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -60, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 400, damping: 30 }}
          className="sticky top-0 z-40 bg-destructive text-destructive-foreground px-4 py-3 shadow-md"
          data-testid="salesman-warning-banner"
        >
          <div className="flex items-start gap-3 max-w-lg mx-auto">
            <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-sm">Teguran dari Manajemen</div>
              <div className="text-sm mt-0.5">{current.message}</div>
              {current.created_by_name && (
                <div className="text-xs opacity-90 mt-1">- {current.created_by_name}</div>
              )}
            </div>
            <Button size="sm" variant="secondary" className="shrink-0" onClick={acknowledge} data-testid="salesman-warning-ack-button">
              Saya Mengerti
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
